<mat-card class="sticky-header mb-2" [style.background-color]="sharedService.blue">
  <mat-card-content>
    <div class="flex flex-row justify-start items-center gap-4">
      <span></span>
      <mat-icon class="medium-icon text-[#303030]">group</mat-icon>
      <span class="text-[#303030] text-xl pl-2">Individual License</span>
    </div>
  </mat-card-content>
</mat-card>

<div class="flex flex-col" *ngIf="license.id === 0" [@slideLeft]>
  <form [formGroup]="searchForm">
    <div class="grid grid-cols-6">
      <div class="flex flex-col md:flex-row col-span-5 gap-1 items-center">
        <mat-form-field>
          <input matInput placeholder="First Name" formControlName="firstName">
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Last Name" formControlName="lastName">
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="License Id" formControlName="licenseId">
        </mat-form-field>
        <mat-form-field>
          <mat-label>
            Assigned To
          </mat-label>
          <mat-select formControlName="assignedTo">
            <mat-option>All</mat-option>
            <mat-option *ngFor="let staff of licenseStaff" value={{staff.id}}>{{staff.name}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>
            Statuses
          </mat-label>
          <mat-select formControlName="statuses" multiple [compareWith]="compareFn">
            <mat-option [value]=null>All</mat-option>
            <mat-option value="Started">Started</mat-option>
            <mat-option value="Submitted">Submitted</mat-option>
            <mat-option value="Denied">Denied</mat-option>
            <mat-option value="Approved">Approved</mat-option>
          </mat-select>
        </mat-form-field>
        <button type="button" mat-button color="primary" (click)="searchLicenses()">Search</button>
        <button type="button" mat-button color="primary" (click)="createLicense()">Add License</button>
      </div>

      <div class="col-start-6 col-end-7 justify-items-end gap-2">
        <mat-form-field class="w-full">
          <input matInput (keyup)="filterTable($event)" placeholder="Filter Results" />
        </mat-form-field>
      </div>
    </div>
  </form>

  <mat-table [dataSource]="licenseSource" matSort #licenseSort="matSort" aria-describedby="entity licenses" class="mat-elevation-z8">
    <ng-container matColumnDef="licenseId">
      <mat-header-cell *matHeaderCellDef>Id</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let license" (click)="selectLicense(license)">
        <span class="mobile-label">Id</span>
        <div class="flex flex-col">
          <span>{{ license.licenseId }}</span>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="legalFirstName">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">First Name</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let license" (click)="selectLicense(license)">
        <span class="mobile-label">First</span>
        {{ license.applicants[0]?.legalFirstName }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="legalLastName">
      <mat-header-cell *matHeaderCellDef>Last Name</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let license" (click)="selectLicense(license)">
        <span class="mobile-label">Last</span>
        <div class="flex flex-col">
          <span>{{ license.applicants[0]?.legalLastName }}</span>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="statuses">
      <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let license" (click)="selectLicense(license)">
        <span class="mobile-label">Status</span>
        <div class="flex flex-col">
          <span *ngFor="let status of license.statuses">{{ status.label }}</span>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="assign">
      <mat-header-cell *matHeaderCellDef>Assign</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let license">
        <mat-form-field [subscriptSizing]="'dynamic'" class="pt-2">
          <mat-select [(value)]="license.assignedToName" (selectionChange)="assignLicense($event, license.id)" shouldLabelFloat="false">
            <mat-option>-- None --</mat-option>
            <mat-option *ngFor="let staff of licenseStaff" value={{staff.name}}>{{staff.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="licenseColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: licenseColumns" class="hover:bg-gray-500 hover:bg-opacity-25"></mat-row>
  </mat-table>
  <mat-paginator [pageSizeOptions]="[5, 10, 20]" #licensePaginator="matPaginator">
  </mat-paginator>
</div>

<div class="flex flex-col gap-4" *ngIf="license.id > 0" [@slideRight]>
  <individual-applicant [entityId]="license.id"
                        [entityType]="sharedService.individualLicense"
                        [statuses]="license.statuses"
                        (closeLicense)="closeLicense()">
  </individual-applicant>

  <div class="flex flex-col gap-6">
    <!-- <app-manage-payments [entityId]="license.id.toString()"
                         [entityType]="sharedService.individualLicense"
                         [allowMultiplePayments]='true'
                         [editingPayment]="true"
                         [allowDelete]='false'>
    </app-manage-payments> -->

    <notes [entityId]="license.id" [entityType]="sharedService.individualLicense"></notes>

    <mat-card>
      <mat-card-header class="mb-4">
        <mat-card-title>
          <span class="text-xl font-semibold">License Status</span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-card [style.background]="sharedService.darkMode? '#303030' : ''">
          <mat-card-content>
            <div class="flex flex-col">
              <div class="grid grid-cols-3 items-center md:w-1/3">
                <span>Status:</span>
                <div class="col-start-2" *ngFor="let status of license.statuses">
                  {{ status.label }}
                </div>
              </div>
              <div class="grid grid-cols-3 md:w-1/3">
                <span>Entered by Staff:</span>
                <span class="col-start-2">
                  {{ license.enteredByStaff? 'Yes' : 'No' }}
                </span>
              </div>
            </div>

            <div class="flex flex-col" *ngIf="complete">
              <div class="grid grid-cols-3 md:w-1/3">
                <span>{{ license.approvedDate !== ''? 'Approved by ' : 'Denied by ' }}</span>
                <span class="col-start-2">{{ license.finalApprovalBy }}</span>
              </div>
              <div class="grid grid-cols-3 md:w-1/3">
                <span>Date {{ license.approvedDate !== ''? 'Approved' : 'Denied' }}:</span>
                <span class="col-start-2">{{ license.approvedDate !== ''? (license.approvedDate | date) : (license.deniedDate | date) }}</span>
              </div>
              <div class="grid grid-cols-3 md:w-1/3">
                <span>Expiration Date:</span>
                <span class="col-start-2">{{ license.expirationDate | date}}</span>
              </div>
            </div>

            <div *ngIf="!complete">
              <div class="flex flex-row gap-2 justify-end items-center">
                <button *ngIf="!complete" type="button" mat-button color="primary" (click)="submitLicense(true)">Approve</button>
                <button *ngIf="!complete" type="button" mat-button color="warn" (click)="submitLicense(false)">Deny</button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </div>
</div>
